import { render, staticRenderFns } from "./CardBodyItem.vue?vue&type=template&id=05e219e4&scoped=true"
import script from "./CardBodyItem.vue?vue&type=script&lang=ts"
export * from "./CardBodyItem.vue?vue&type=script&lang=ts"
import style0 from "./CardBodyItem.vue?vue&type=style&index=0&id=05e219e4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e219e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05e219e4')) {
      api.createRecord('05e219e4', component.options)
    } else {
      api.reload('05e219e4', component.options)
    }
    module.hot.accept("./CardBodyItem.vue?vue&type=template&id=05e219e4&scoped=true", function () {
      api.rerender('05e219e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/CardBodyItem.vue"
export default component.exports